import { collection, doc, getDocs, setDoc } from 'firebase/firestore';
import { useAuthContext } from '../../contexts/AuthContext';
import { Condominium, Service } from '../../entities';
import { Collections, db } from '../../utils/firebase.config';
import { converterOf } from '../../utils/firebase.utils';

export const useServices = (condominiumId: string) => {
  const condominiumsCollection = collection(db, Collections.Condominiums).withConverter(converterOf(Condominium));
  const condominiumsDoc = doc(condominiumsCollection, condominiumId);

  const servicesCollection = collection(condominiumsDoc, Collections.Services).withConverter(converterOf(Service));

  const { user } = useAuthContext();

  const fetchAll = async (): Promise<Service[]> => {
    const response = await getDocs(servicesCollection);

    return response.docs.map((serviceDoc) => serviceDoc.data());
  };

  const create = async (input: Omit<Service, 'id'>): Promise<Service> => {
    const serviceDoc = doc(servicesCollection);

    const newService = new Service({
      ...input,
      id: serviceDoc.id,
      created: {
        at: new Date(),
        by: user?.uid!,
      },
    });

    await setDoc(serviceDoc, newService);

    return newService;
  };

  const update = async (input: Partial<Service> & { id: string }): Promise<void> => {
    const serviceDoc = doc(servicesCollection, input.id);

    const instance = new Service({ ...input, updated: { at: new Date(), by: user?.uid! } });

    return setDoc(serviceDoc, instance, { merge: true });
  };

  return { fetchAll, create, update };
};

export default useServices;
